import Breadcumb from "./Breadcrumb";

export default function Content({ children, title, breadcrumb, module }) {
  return (
    <main className="main-body">
      <div className="content">
        <Breadcumb breadcrumb={breadcrumb} module={module} />

        {/* <!-- content --> */}
        <div className="row flex-fill g-4">
          <div className="col-md-12">
            <div className="white-box">
              <div className="white-box-header">
                <h1>{title}</h1>
              </div>
              {children}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
